/* __next_internal_client_entry_do_not_use__ BannerImages auto */ import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";
import { SDUIImage, objectFitCoverImageStyles } from "@faire/retailer/components/SDUI/__internal__/Image/SDUIImage";
import { numberToPixel } from "@faire/retailer/components/SDUI/__internal__/Styling/conversions";
import { convertServerResponsivePropertyToClientResponsiveProperty, getResponsiveValueAtIndex } from "@faire/retailer/components/SDUI/__internal__/Styling/responsiveValues";
import * as styles from "./style.css";
export var BannerImages = function(param) {
    var images = param.images, serverResponsiveImages = param.responsiveImages, variant = param.variant, renderBehaviour = param.renderBehaviour;
    var _bannerImage_tabletAndAbove, _bannerImage_mobileAndAbove, _bannerImage_desktopAndAbove;
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    if (variant === "left" && !isTabletAndAbove) {
        return null;
    }
    var responsiveImages = convertServerResponsivePropertyToClientResponsiveProperty(images, function(img) {
        return img;
    }, serverResponsiveImages);
    if (responsiveImages.mobileAndAbove.length === 0) {
        return null;
    }
    var bannerImage = getResponsiveValueAtIndex(responsiveImages, 0, IImage.build());
    var _bannerImage_tabletAndAbove_width;
    var tabletImageWidth = (_bannerImage_tabletAndAbove_width = (_bannerImage_tabletAndAbove = bannerImage.tabletAndAbove) === null || _bannerImage_tabletAndAbove === void 0 ? void 0 : _bannerImage_tabletAndAbove.width) !== null && _bannerImage_tabletAndAbove_width !== void 0 ? _bannerImage_tabletAndAbove_width : (_bannerImage_mobileAndAbove = bannerImage.mobileAndAbove) === null || _bannerImage_mobileAndAbove === void 0 ? void 0 : _bannerImage_mobileAndAbove.width;
    var _bannerImage_desktopAndAbove_width;
    var desktopImageWidth = (_bannerImage_desktopAndAbove_width = (_bannerImage_desktopAndAbove = bannerImage.desktopAndAbove) === null || _bannerImage_desktopAndAbove === void 0 ? void 0 : _bannerImage_desktopAndAbove.width) !== null && _bannerImage_desktopAndAbove_width !== void 0 ? _bannerImage_desktopAndAbove_width : tabletImageWidth;
    var optimizeImageOptions = {
        mobileAndAbove: {
            height: styles.MOBILE_IMAGE_HEIGHT
        },
        tabletAndAbove: {
            width: tabletImageWidth !== null && tabletImageWidth !== void 0 ? tabletImageWidth : styles.DESKTOP_IMAGE_WIDTH
        },
        desktopAndAbove: {
            width: desktopImageWidth !== null && desktopImageWidth !== void 0 ? desktopImageWidth : styles.DESKTOP_IMAGE_WIDTH
        }
    };
    var _numberToPixel, _numberToPixel1;
    var _obj;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.singleImage,
        style: assignInlineVars((_obj = {}, _define_property(_obj, styles.varSingleBannerImageWidthTablet, (_numberToPixel = numberToPixel(tabletImageWidth)) !== null && _numberToPixel !== void 0 ? _numberToPixel : "auto"), _define_property(_obj, styles.varSingleBannerImageWidthDesktop, (_numberToPixel1 = numberToPixel(desktopImageWidth)) !== null && _numberToPixel1 !== void 0 ? _numberToPixel1 : "auto"), _obj)),
        children: /*#__PURE__*/ _jsx(SDUIImage, {
            responsiveImage: bannerImage,
            optimizeImageOptions: optimizeImageOptions,
            imageStyles: objectFitCoverImageStyles,
            renderBehaviour: renderBehaviour
        })
    });
};
